




















































































































import { VNode, CreateElement } from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { TableEntry, SwTable, TableColumnConfig, ColumnsAdjustRequestData, TableEntrySelectingEventData } from '@libs-uuif/shared/sw-table';
import { UserGroup, UserGroupReponse, MSSPPrefilterResponseType } from './userGroupTypes';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import  { MswApiService } from '@/shared/msw-api-service';
import { currentUserKey } from '@/shared/msw-constants';
import { InfoState } from '@/core';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';

const cssPrefix = 'user-group-container';
@Component({
  components: {
    ...UUIFComponents,
    SwTable,
    SwSelect,
    SwTextfield,
    SwIconButton,
  },
})
export default class UserGroupContainer  extends SwExtendedVue {
  cssPrefix = cssPrefix;
  userGroupCount = 0;
  searchString: string = '';
  userGroupContainerTableData: TableEntry[] = [];
  adjustedColumns: ColumnsAdjustRequestData = {};
  userGroupFromApi: UserGroup[] = [];
  filteredData: TableEntry[] = [];
  msspOptions: SelectOption[] = [];
  selectedMssp: string = '';
  newUserGroupName = '';
  addNewUserGroupFlag = false;
  userErrorPath = '';
  userGroupValidation: boolean = false;
  clickToSelect: boolean = true;
  isREstrictedMsspFromApi: string = '';
  userGroupNameEdit: any = '';
  ifClicked: boolean = false;

  @Prop()
  activeMssp: SelectOption[];

  @Prop()
  initialSelectedMssp: string;

  @Prop()
  msspPrefilterResponse: MSSPPrefilterResponseType;

  get tableData() {
    return this.filteredData;
  }

  onAddNewUserGroup() {
    this.userGroupValidation = false;
    setTimeout(() => {
      const newUserGroupElement = document.getElementById('newUserGroupName') as HTMLElement;
      if (newUserGroupElement) {
        newUserGroupElement.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         500);
    if (!this.addNewUserGroupFlag && (this.filteredData[0] ? this.filteredData[0]._key !== 'newEntry' : true)) {
      this.newUserGroupName = '';
      const newUserGroupEntry = [{
        _key: 'newEntry',
      }];
      this.filteredData = [...newUserGroupEntry, ...this.filteredData];
    }

  }

  commonOnEntrySelecting(data: TableEntrySelectingEventData, toSet: Set<string>, toShadow: string[]) {
    if (data.selecting) {
      toSet.add(data.entryKey);
      this.setSelectedUserGroupState(data.entryKey);
    } else {
      toSet.delete(data.entryKey);
    }
    toShadow.splice(0);
    Array.prototype.push.apply(toShadow, Array.from(toSet));
  }

  singleSelectedEntries = new Set<string>();
  shadowSingleSelectedEntries: string[] = [];
  onSingleSelectEntry(data: TableEntrySelectingEventData) {
    this.commonOnEntrySelecting(data, this.singleSelectedEntries, this.shadowSingleSelectedEntries);
  }

  setSelectedUserGroupState(index: string) {
    const selctedUserGroupRow = this.filteredData.filter((ele: any) =>  ele._key === [Number(index)].toString())[0];
    if (selctedUserGroupRow) {
      const selectedUSerGroupObject = Object.assign({}, {
        partyGroupName: selctedUserGroupRow.partyGroupName,
        isDefaultGroup: selctedUserGroupRow.isDefaultGroup,
        partyGroupId: selctedUserGroupRow.partyGroupId,
        adminPartyId: selctedUserGroupRow.adminPartyId,
        status: selctedUserGroupRow.status,
        totalContacts: selctedUserGroupRow.totalContacts,
        productGroupName: selctedUserGroupRow.productGroupName,
        associatedPGList: selctedUserGroupRow.associatedPGList,
        setAsDefaultGroup: selctedUserGroupRow.setAsDefaultGroup,
        renameLink: selctedUserGroupRow.renameLink,
        usersForUserGroup: selctedUserGroupRow.usersForUserGroup,
        deleteLink: selctedUserGroupRow.deleteLink,
        mgeProdGrpPagelink: selctedUserGroupRow.mgeProdGrpPagelink,
        isReadOnlyAccess: selctedUserGroupRow.isReadOnlyAccess,
        MSSPID: selctedUserGroupRow.MSSPID,
        isAllMSSPTenants: selctedUserGroupRow.isAllMSSPTenants,
        msspScope: selctedUserGroupRow.msspScope,
        scopedMSSPID: selctedUserGroupRow.scopedMSSPID,
      });
      this.$store.commit('AccessManagementStoreModule/setSelectedUserGroupObject', { selectedUserGroupObject: selectedUSerGroupObject });
      this.$store.commit('AccessManagementStoreModule/setUserGroupNameFromUserListPage', { setSelectedUserGroupName: '' });
      this.$emit('setSelectedUserGroup');
    }
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  closeCreateNewUserGroup() {
    this.userGroupValidation = false;
    this.addNewUserGroupFlag = false;
    const tempData = [...this.filteredData.slice(1)];
    this.filteredData = [...tempData];
    this.userGroupValidation = false;
  }

  createNewUserGroupApi() {
    if (this.newUserGroupName.trim() !== '') {
      this.addNewUserGroupFlag = false;
      this.filteredData = this.filteredData.slice(1);
      this.$emit('createNewUserGroup', this.newUserGroupName);
    } else {
      this.userErrorPath = String(this.$t('accessMgmt.fieldEmpty'));
      this.userGroupValidation = true;
    }
  }

  onUserGroupName() {
    if (this.newUserGroupName.trim() !== '') {
      this.userGroupValidation = false;
    }
  }

  /* tslint:disable-next-line */
  renderAddUserName(h: CreateElement, data: { entry: TableEntry }) {
    if (data.entry._key === 'newEntry') {
      return (
        <div class="createNewUserGroupRow">
          <SwTextfield
            id={'newUserGroupName'}
            name={'newUserGroupName'}
            props-value = {this.newUserGroupName}
            on-input={ (value: any) => {
              this.newUserGroupName = value;
              this.onUserGroupName();
            } }
            on-enter={this.createNewUserGroupApi}
          />
          <SwIcon
            class="createNewUserGroupRow_icon"
            props-size={16}
            name="checkmark"
            color="#99CC00"
            props-disabled={this.newUserGroupName === ''}
            nativeOn-click={() => {
              this.createNewUserGroupApi();
            }}
          />
          <span  style="borderRight:1px solid #C6D1DE">&nbsp;</span>
          <SwIcon
            class="createNewUserGroupRow_icon"
            props-size={16}
            name="close"
            color="#ff0000"
            nativeOn-click={() => {
              this.closeCreateNewUserGroup();
            }}
          />
          {this.userGroupValidation ? <label style={{ color: '#CE1126', fontWeight: '400', fontSize: '13px' }}>{this.userErrorPath}</label> : <span></span>}
        </div>
      ) as VNode;
    }
    // let editUserGrpName: boolean = false;
    return (this.userGrpNameColumnRenderer(h, data)) as VNode;
  }
  userGroupColumnConfig: TableColumnConfig[] = [
    {
      key: 'partyGroupName',
      dataKey: 'partyGroupName',
      title: String(this.$t('accessMgmt.name')),
      /* tslint:disable-next-line */
      render: this.renderAddUserName,
    },
    {
      key: 'users',
      dataKey: 'users',
      title: String(this.$t('accessMgmt.users')),
      width: 80,
    },
  ];

  userGrpNameColumnRenderer(h: CreateElement, data: { entry: TableEntry }) { // tslint:disable-line
    return (
      <div
        class="friendlyname_col"
        on-mouseenter={() => { !this.ifClicked  && (this.userGroupNameEdit =  data.entry._key); } }
        on-mouseleave={() => { !this.ifClicked && (this.userGroupNameEdit = ''); }}
      >
        { !data.entry.editUserGrpName && <div class="friendlyname_col_text_field">
          <span class="friendlyname_col_text first_col_text"  title = {data.entry.partyGroupName}>
          { data.entry.partyGroupName }
          </span>
          {(data.entry.isDefaultGroup === 'TRUE') && <span style="margin-left: 0.75rem;">
            <SwIcon
              class=""
              v-tooltip={{
                content: String(this.$t('accessMgmt.defaultGroup')),
                placement: 'top',
                compact: true,
              }}
              name="user"
              size="small"
            /></span>
          }
          {(data.entry.renameLink.toLowerCase() === 'true' &&  !this.ifClicked && this.userGroupNameEdit === data.entry._key) && <span>
            <SwIconButton
              class=""
              name="editIcon"
              icon="pencil"
              size="small"
              nativeOn-click={() => {
                data.entry.editUserGrpName = true;
                this.ifClicked = true;
                this.userGroupNameEdit = '';
              }}
            /></span>
          }
          {(data.entry.deleteLink.toLowerCase() === 'true' &&  !this.ifClicked && this.userGroupNameEdit === data.entry._key) && <span>
            <SwIconButton
              class=""
              name="deleteIcon"
              icon="trash"
              size="small"
              nativeOn-click={() => {
                this.ifClicked = true;
                this.userGroupNameEdit = '';
                this.deleteUserGroup(data.entry.partyGroupId);
              }}
            /></span>
          }
        </div>}
        { data.entry.editUserGrpName && <div class="friendlyname_col_edit_text">
          <SwTextfield
            v-tooltip={{
              enabled: !data.entry.partyGroupName.trim(),
              placement: 'top',
              persistent: true,
              compact: true,
              content: (this.$t('products.friendlyNameEmpty')
              .toString()),
            }}
            name={data.entry.partyGroupName}
            props-value = {data.entry.partyGroupName}
            on-input={(e:any) =>
              { if (e.length <= 50) data.entry.partyGroupName = e; }
            }
          ></SwTextfield>
          <SwIcon class="friendlyname_col_true_icon" props-size={14} name="checkmark" color="#99CC00"
            nativeOn-click={async () => {
              if (data.entry.partyGroupName.trim().length > 0) {
                const renamingUsrGrp:any = await this.renameProduct(data.entry.partyGroupName, data.entry.partyGroupId);
                if (renamingUsrGrp === true) {
                  this.ifClicked = false;
                  data.entry.editUserGrpName = false;
                } else {
                  this.ifClicked = false;
                  data.entry.partyGroupName = data.entry.partyGroupNameBeforeEdit;
                  data.entry.editUserGrpName = false;
                }
              }
            }
          }></SwIcon>
          <span  style="borderRight:1px solid #C6D1DE">&nbsp;</span>
          <SwIcon class="friendlyname_col_true_icon" props-size={12} name="close" color="#ff0000"
            nativeOn-click={() => {
              data.entry.partyGroupName = data.entry.partyGroupNameBeforeEdit;
              data.entry.editUserGrpName = false;
              this.ifClicked = false;
            }
          }></SwIcon>
        </div>}
      </div>
      ) as VNode;
  }

  async renameProduct(newUserGroupname:any, prodGrpId:any) {
    const payload = {
      partyGroupId: prodGrpId,
      newPartyGroupName: newUserGroupname,
      bSendMail: false,
    };
    this.$store.commit('startLoading');
    MswApiService.createCustomer.editUserGroup(payload)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'NOK') {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
          return false;
        }
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
        this.fetchUserGroupForMsspSelected();
        return true;
      })
      .catch((err:any) => {
        this.$store.commit('stopLoading');
        console.error(err);
        return false;
      });
  }

  deleteUserGroup(userGroupId:any) {
    confirmService.confirm({
      status: 'major',
      title: 'Delete user group',
      message: 'Are you sure you want to delete the user group?',
      buttons: [
        {
          key: 'cancel',
          name: this.$t('common.cancel')
          .toString(),
        },
        {
          key: 'ok',
          name: this.$t('common.confirm')
          .toString(),
          isDefault: true,
        },
      ],
    })
    .then((isConfirmed : any) => {
      if (isConfirmed === 'ok') {
        this.ifClicked = false;
        const payload = {
          bsendMail:false,
          userGroupList:[{ partyGroupId: userGroupId }],
        };
        this.$store.commit('startLoading');
        MswApiService.createCustomer.deleteUserGroup(payload)
        .then((resp: any) => {
          this.$store.commit('stopLoading');
          if (resp.msgCode !== 'MSWAPP:DELTEUSERGROUPSUCCESS') {
            const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
          } else {
            this.resetSelectedUserGroup();
            this.fetchUserGroupForMsspSelected();
            const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
          }
        })
        .catch((err:any) => {
          this.$store.commit('stopLoading');
          console.error(err);
        });
      } else {
        this.ifClicked = false;
      }
    });
  }

  performSearch() {
    const obj = this.searchString.toString()
    .toLocaleLowerCase();
    if (obj !== '') {
      this.filteredData = this.userGroupContainerTableData.filter((row: any) => {
        let flag = false;
        for (const key in row) {
          if (Object.prototype.hasOwnProperty.call(row, key) && (key === 'partyGroupName' || key === 'users')) {
            flag = row[key] ? row[key].toString()
            .toLocaleLowerCase()
            .includes(obj) : false;
            if (flag) {
              return flag;
            }
          }
        }
        return false;
      });
    } else {
      this.filteredData = [...this.userGroupContainerTableData];
    }
  }

  @Watch('usergroupEntry')
  formatUserGroupTable() {
    this.initializeValue();
    this.filteredData = [];
    this.userGroupContainerTableData = [];
    this.isREstrictedMsspFromApi = this.$store.getters['AccessManagementStoreModule/getisRestrictedMSSPAccess'];
    this.userGroupFromApi = this.$store.getters['AccessManagementStoreModule/getUserGroupArray'];
    // const selectedUserGroup = this.$store.getters['AccessManagementStoreModule/getSelectedUserGroupObject'];
    const tempUserGroupData: TableEntry[] = [];
    this.userGroupFromApi.map((ele: UserGroup, index: any) => {
      if (this.selectedMssp === ele.MSSPID.toString()) {
        tempUserGroupData.push({
          _key: index.toString(),
          partyGroupName: ele.partyGroupName,
          users: `${ele.usersForUserGroup ? ele.usersForUserGroup.length : 0} Users`,
          isDefaultGroup: ele.isDefaultGroup,
          partyGroupId: ele.partyGroupId,
          adminPartyId: ele.adminPartyId,
          status: ele.status,
          totalContacts: ele.totalContacts,
          productGroupName: ele.productGroupName,
          associatedPGList: ele.associatedPGList,
          setAsDefaultGroup: ele.setAsDefaultGroup,
          renameLink: ele.renameLink,
          usersForUserGroup: ele.usersForUserGroup,
          deleteLink: ele.deleteLink,
          mgeProdGrpPagelink: ele.mgeProdGrpPagelink,
          isReadOnlyAccess: ele.isReadOnlyAccess,
          MSSPID: ele.MSSPID,
          isAllMSSPTenants: ele.isAllMSSPTenants,
          msspScope: ele.msspScope,
          scopedMSSPID: ele.scopedMSSPID,
          editUserGrpName: false,
          partyGroupNameBeforeEdit: ele.partyGroupName,
        });
      }
    });
    this.userGroupContainerTableData = [...tempUserGroupData];
    this.filteredData = [...this.userGroupContainerTableData];
  }

  get usergroupEntry() {
    return this.$store.getters['AccessManagementStoreModule/getUserGroupArray'];
  }

  resetSelectedUserGroup() {
    const selectedUSerGroupObject = Object.assign({}, {
      partyGroupName: '',
      isDefaultGroup: '',
      partyGroupId: '',
      adminPartyId: '',
      status: '',
      totalContacts: '',
      productGroupName: '',
      associatedPGList: [],
      setAsDefaultGroup: '',
      renameLink: '',
      usersForUserGroup: [],
      deleteLink: '',
      mgeProdGrpPagelink: '',
      isReadOnlyAccess: '',
      MSSPID: '',
      isAllMSSPTenants: '',
      msspScope: '',
      scopedMSSPID: '',
    });
    this.$store.commit('AccessManagementStoreModule/setSelectedUserGroupObject', { selectedUserGroupObject: selectedUSerGroupObject });
  }

  fetchUserGroupForMsspSelected() {
    return new Promise((res: any) => {
      const dataToBePosted = {
        isForced: 'true',
        mode: '',
        masterMSSPID: this.selectedMssp,
        isfromMSSPPage: 'YES',
        skipUsers: 'NO',
      };
      // MswApiService.userGroup.getUserGroupList()
      MswApiService.userGroup.getUserGroupListForMsspId(dataToBePosted)
      .then((resp: UserGroupReponse) => {
        this.userGroupFromApi = resp.userGroups || [];
        if (this.shadowSingleSelectedEntries[0]) {
          this.onSingleSelectEntry({ entryKey: this.shadowSingleSelectedEntries[0], selecting: false });
        }
        this.$store.commit('AccessManagementStoreModule/setUserGroups', { userGroups: resp.userGroups || [] });
        this.$store.commit('AccessManagementStoreModule/setisRestrictedMSSPAccess', { isRestrictedMSSPAccess: resp.isRestrictedMSSPAccess });
        res(true);
      })
      .catch(() => {
        res(true);
      });
    });
  }

  async onChangeMssp() {
    this.$store.commit('startLoading');
    this.$store.commit('AccessManagementStoreModule/setSelectedMssp', { selectedMssp: this.selectedMssp });
    this.$store.commit('AccessManagementStoreModule/setSelectedMsspObject', { selectedMsspObject:  this.fetchSelectedMsspDetails(this.selectedMssp) });
    this.filteredData = [];
    this.resetSelectedUserGroup();
    await this.fetchUserGroupForMsspSelected();
    setTimeout(() => {
      this.$store.commit('stopLoading');
    },         3000);
  }

  fetchSelectedMsspDetails(id: string) {
    let msspDetails = {
      MSSPName: '',
      MSSPID: 0,
      Tenants: [],
      isGlobal: '',
    };
    this.msspPrefilterResponse.content.MSSPs.map((ele: any) => {
      if (ele.MSSPID.toString() === id) {
        msspDetails = Object.assign({}, {
          MSSPName: ele.MSSPName,
          MSSPID: ele.MSSPID,
          Tenants: ele.Tenants || [],
          isGlobal: ele.isGlobal,
        });
      }
    });
    return msspDetails;
  }

  initializeValue() {
    this.filteredData = [];
    this.msspOptions = [...this.activeMssp];
    this.selectedMssp = this.selectedMssp === '' ? this.initialSelectedMssp : this.selectedMssp;
    this.$store.commit('AccessManagementStoreModule/setSelectedMsspObject', { selectedMsspObject:  this.fetchSelectedMsspDetails(this.selectedMssp) });
  }

  get checkForMasterMsspRole() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    console.warn(userInfoObtained, userInfoObtained.roles);
    if (userInfoObtained.roles && userInfoObtained.roles.includes('MASTERMSSP')) {
      return true;
    }
    return false;
  }

  created() {
    this.initializeValue();
    this.selectedMssp = this.initialSelectedMssp;
    this.formatUserGroupTable();
  }

  beforeDestroy() {
    this.resetSelectedUserGroup();
  }
}
